import { clientEnvIsAndroid } from "@/modules/client-env/isAndroid";
import { clientEnvIsIOS } from "@/modules/client-env/isIOS";

export const clientEnvIsMobile = () => {
  return clientEnvIsAndroid() || clientEnvIsIOS();
};
